RivalIQ.apps.Insights.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    App.BaseDimensionTableView = RivalIQ.apps.Dashboard.widgets.MetricTable.mixin({
        mixins: {
            LoadDataWithBuffering: RivalIQ.apps.Dashboard.mixins.LoadDataWithBuffering
        },

        ui: _.defaults({
            tooltips: '[data-toggle="tooltip"]'
        }, RivalIQ.apps.Dashboard.widgets.MetricTable.prototype.ui),

        rowClassName: 'discovery-table-row pointer',

        rowClass: function (cells, i) {
            const me = this;

            let rowClass = RivalIQ.apps.Dashboard.widgets.MetricTable.prototype.rowClass.apply(me, arguments);
            if (_.get(cells, [0, 0]) === '__SUMMARY_ROW__') {
                rowClass += ' metric-summary-row';
            }

            return rowClass;
        },

        _loadData: RivalIQ.apps.Dashboard.widgets.MetricTable.prototype.loadData,

        onRender: function () {
            const me = this;
            me.ui.tooltips.tooltip();
        }
    });
});
